<template>
  <shared-product-provide :product="product" :fromModule="fromModule" :toModule="toModule">
    <loader :loading="loadingCategories || loadingAttributes"/>

    <multiselect slot="brands" v-model="productBrand" :options="this.brands" selectLabel="Clique" selectedLabel="Selecionado"
                 label="label" track-by="code" placeholder="Selecione a opção" :disabled="disabledInputs()">
    </multiselect>

    <form-group :label="$t('category.label')" :columns="12" :error="getError('category', product.productId)"
                :required="true">
      <multiselect
        v-model="category"
        :options="categories"
        selectLabel=""
        selectedLabel=""
        placeholder="Escolha"
        label="label"
        track-by="code"
      />
    </form-group>

    <form-group :label="$t('warranty.label')" :columns="12" :error="getError('warranty', product.productId)" :required="true">
      <select v-model="warranty" class="form-select" required>
        <option v-for="warranty in warranties" :value="warranty">{{ warranty }}</option>
      </select>
    </form-group>

    <div class="l-col-12@md" v-if="attributes.length">
      <div class="divider"><span>Atributos</span></div>
    </div>
    <form-group v-for="(attribute, index) in attributes" :key="attribute.code" :label="attribute.label" :columns="3"
                :error="getError(attribute.code, product.productId)" :required="attribute.required">
      <select v-model="attribute.value" class="form-select" :disabled="disabledInputs()"
              v-if="attribute.typeSelection === 'select'">
        <option value="undefined">{{ $t('choose.label') }}</option>
        <option v-for="option in attribute.values" :value="option">{{ option }}</option>
      </select>
      <multiselect v-model="attribute.value" :options="attribute.values" :multiple="true"
                   v-else-if="attribute.typeSelection === 'multiselect'" selectLabel="Clique"
                   selectedLabel="Selecionado" placeholder="Selecione a opção">
      </multiselect>
      <input class="form-input" type="text" v-model="attribute.value" :disabled="disabledInputs()" v-else>
    </form-group>
  </shared-product-provide>
</template>

<script>
  import { isArray, cloneDeep } from 'lodash'
  import api from '@/api'
  import { mapActions, mapGetters } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import SharedProductProvide from '@/components/marketplace/shared/provide/Product'
  import FormGroup from '@/components/template/FormGroup'
  import Multiselect from 'vue-multiselect'
  import Loader from '@/components/template/Loader'
  import utils from 'utiljs-strings'
  import { AllHtmlEntities } from 'html-entities'

  export default {
    provide: {
      moduleDI: {
        type: 'marketplace',
        identifier: 'gfg'
      },
      maxDescriptionLengthDI: 25000,
      allowDescriptionHtml: false
    },
    data: () => ({
      loadingCategories: false,
      loadingAttributes: false,
      attributes: [],
      categories: [],
      warranties: [],
      category: null,
      warranty: 'Sem Garantia',
      productBrand: null,
      attributesToIgnore: [
        'Brand',
        'Name',
        'Description',
        'PrimaryCategory',
        'BoxHeight',
        'BoxWidth',
        'BoxLength',
        'Weight',
        'Price',
        'SalePrice',
        'ProductId',
        'SellerSku',
        'ParentSku',
        'Quantity',
        'ShipmentType',
        'TaxClass'
      ]
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      fromModule: {
        type: Object,
        required: true
      },
      toModule: {
        type: Object,
        required: true
      }
    },
    async mounted () {
      this.loadingCategories = true

      try {
        this.categories = await api.getCategories('marketplace', 'gfg')
      } catch (e) {
        this.categories = []
      } finally {
        this.loadingCategories = false
      }
      this.product.category = ''

      const presetCategorization = this.$parent.getPresetItemsCategorization(this.product.categories)

      if (presetCategorization !== null && presetCategorization !== undefined) {
        this.category = this.categories.find(category => category.code === presetCategorization.category)
      }

      if (!this.brands.length) {
        try {
          await this.fetchBrands(this.toModule)
        } catch (e) {
          //
        }
      }

      const presetBrand = this.$parent.getPresetItemByTypeAndFrom('brand', { brand: this.product.brand })
      if (presetBrand !== null && presetBrand !== undefined) {
        this.product.brand = presetBrand.brand
      }

      if (this.brands.indexOf(this.product.brand) === -1 && this.product.brand) {
        const brand = this.brands.find(brand => brand.label.toLowerCase() === this.product.brand.toLowerCase())

        if (brand !== undefined) {
          this.productBrand = brand
        } else {
          this.productBrand = null
        }
      }

      if (this.product.warranty) {
        this.product.warranty = utils.stripTags(AllHtmlEntities.decode(this.product.warranty), '')
      }
      this.$parent.loadingProducts(false)
    },
    methods: {
      ...mapActions('errors', [
        'addError',
        'clearErrors'
      ]),
      ...mapActions('marketplaceBrands', [
        'fetchBrands'
      ]),
      formatProduct () {
        this.clearErrors()

        this.product.variations
          .filter(variation => variation.selected)
          .map(variation => {
            variation.gfgAttributes.map(attribute => {
              if (attribute.required && (attribute.value === undefined || attribute.value === null)) {
                this.addError({
                  productId: this.product.productId,
                  sku: variation.sku,
                  property: attribute.code,
                  error: {
                    message: 'required',
                    value: 1
                  }
                })
              }
            })
          })

        return this.product.variations
          .filter(variation => variation.selected)
          .map(variation => {
            const attributes = variation.gfgAttributes
              .filter(attribute => {
                if (isArray(attribute.value)) {
                  return attribute.value.length
                }

                return attribute.value !== undefined && attribute.value.trim() !== ''
              })
              .map(attribute => {
                return {
                  id: attribute.code,
                  label: attribute.label,
                  valueId: attribute.value !== undefined && !isArray(attribute.value) ? [attribute.value] : attribute.value,
                  valueLabel: attribute.value !== undefined && !isArray(attribute.value) ? [attribute.value].join((', ')) : attribute.value.join((', '))
                }
              })

            return {
              attributes: attributes,
              brand: this.product.brand,
              condition: 'new',
              color: variation.attributes.color !== undefined ? variation.attributes.color : 'Única',
              grid: this.getGrid(variation),
              gridType: this.getType(variation),
              description: this.product.description,
              ean: variation.ean,
              height: variation.height,
              images: variation.images.length ? variation.images : null,
              integrationCode: this.product.productId,
              length: variation.length,
              original: {
                product: this.product,
                variation: variation
              },
              price: variation.price,
              primaryCategory: this.product.category,
              productId: this.product.productId,
              sku: variation.sku,
              source: this.fromModule,
              stock: variation.stock,
              title: this.product.title,
              weight: variation.weight,
              width: variation.width,
              gender: variation.gender,
              warranty: this.warranty
            }
          }
        )
      },
      disabledInputs () {
        return this.product.status === 'sent' || this.product.status === 'error'
      },
      clearAttributes () {
        this.product.variations.forEach(variation => (this.$set(variation, 'gfgAttributes', [])))
      },
      getAttributes () {
        this.loadingAttributes = true
        if (!this.product.category) {
          this.clearAttributes()
          return false
        }
        api.gfg.getAttributes(this.category.code)
          .then(attributes => {
            attributes.forEach(attribute => {
              if (attribute.code === 'Warranty') {
                this.warranties = attribute.values
              }
            })
            const variationAttributes = cloneDeep(attributes).filter(attribute => this.attributesToIgnore.indexOf(attribute.code) === -1)
            this.product.variations.forEach(variation => {
              const clone = cloneDeep(variationAttributes)
              if (this.toModuleDefinition.module.configs.product.origin) {
                clone[clone.findIndex(attribute => attribute.code === 'Origin')]['value'] = this.toModuleDefinition.module.configs.product.origin
              }
              if (this.toModuleDefinition.module.configs.product.originCountry) {
                clone[clone.findIndex(attribute => attribute.code === 'Origincountry')]['value'] = this.toModuleDefinition.module.configs.product.originCountry
              }
              clone[clone.findIndex(attribute => attribute.code === 'Gender')]['value'] = this.getGender(variation.gender, this.product.ageGroup)
              clone[clone.findIndex(attribute => attribute.code === 'Origincountry')]['required'] = true
              this.$set(variation, 'gfgAttributes', cloneDeep(clone))
              this.$set(variation, 'category', cloneDeep(this.category.code))
            })
          })
          .catch(() => {
            this.product.variations.forEach(variation => (this.$set(variation, 'gfgAttributes', [])))
          })
          .finally(() => {
            this.loadingAttributes = false
          })
      },
      getType (variation) {
        if (variation.attributes['voltage']) {
          return 'voltage'
        }

        return 'size'
      },
      getGrid (variation) {
        if (variation.attributes['voltage']) {
          return variation.attributes['voltage']
        }

        if (variation.attributes['size']) {
          return variation.attributes['size']
        }

        return null
      },
      getGender (gender, ageGroup) {
        switch (gender) {
          case 'male':
            return ageGroup === 'kids' ? 'menino' : 'masculino'

          case 'female':
            return ageGroup === 'kids' ? 'menina' : 'feminino'

          case 'unissex':
            return 'unissex'
        }
      }
    },
    computed: {
      ...mapGetters('errors', [
        'getError'
      ]),
      ...mapFields({
        brands: 'marketplaceBrands.brands'
      }),
      ...mapGetters('errors', [
        'getError'
      ]),
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType'
      ]),
      toModuleDefinition () {
        return this.getDefinitionModuleByIdentifierAndType(this.toModule.type, this.toModule.identifier)
      },
      brandOptions () {
        return `<option value="null">Selecione</option>` +
          this.brands
            .map(brand => `<option value="${brand.label}">${brand.label}</option>`)
            .join(`\n`)
      }
    },
    watch: {
      category (value) {
        this.product.category = value.code

        this.attributes = []

        this.getAttributes()
      },
      productBrand (value) {
        if (!value) {
          this.product.brand = null
          return
        }

        this.product.brand = value.label
      }
    },
    components: {
      SharedProductProvide,
      FormGroup,
      Multiselect,
      Loader
    }
  }
</script>



// WEBPACK FOOTER //
// Product.vue?eca54666